export enum WidgetKind {
  STATS = "STATS",
  LAST_ENTRIES = "LAST_ENTRIES",
  TASK_STATS = "TASK_STATS",
  CLOSED_ENTITIES = "CLOSED_ENTITIES",
}
